var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSmsStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.761 3.389c.14.28.49.54.8.6l.38.06c1.14.19 1.41 1.03.59 1.86l-.35.35c-.23.24-.36.7-.29 1.02l.05.21c.31 1.38-.42 1.91-1.62 1.19l-.26-.15c-.31-.18-.81-.18-1.12 0l-.26.15c-1.21.73-1.94.19-1.62-1.19l.05-.21c.07-.32-.06-.78-.29-1.02l-.35-.36c-.82-.83-.55-1.67.59-1.86l.38-.06c.3-.05.66-.32.8-.6l.28-.57c.54-1.08 1.42-1.08 1.96.01l.28.57z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.76 10.09a.562.562 0 0 0-.52 0c-.57.29-1.09.41-1.5.41-.64 0-1.09-.25-1.31-.41-.37-.27-1.15-1.04-.88-2.67a.572.572 0 0 0-.13-.47c-.69-.79-1.07-1.85-.8-2.68.1-.33-.11-.77-.45-.77H7c-3 0-5 1.5-5 5v7c0 3.5 2 5 5 5h10c3 0 5-1.5 5-5v-5.23c0-.19-.27-.29-.43-.18-.36.26-1.37.74-2.81 0zM12 12.88c-.84 0-1.69-.26-2.34-.79l-3.13-2.5a.77.77 0 0 1-.12-1.06c.26-.32.73-.38 1.05-.12l3.13 2.5c.76.61 2.05.61 2.81 0 .32-.26.79-.21 1.05.12.27.32.22.8-.11 1.06-.66.53-1.5.79-2.34.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSmsStar);
export default __webpack_public_path__ + "static/media/vuesax-bold-sms-star.f7e22102ba78fb7258a96611790a76f5.svg";
export { ForwardRef as ReactComponent };